// workdayService.js
import request from '@/utils/request';
import employeeService from './employeeService';

export default {
    addData(oid, data) {
        return request({
            url: '/workday/add',
            method: 'post',
            params: { oid },
            data
        });
    },

    updateData(oid, data) {
        return request({
            url: '/workday/update',
            method: 'post',
            params: { oid },
            data
        });
    },



    deleteData(oid, ids) {
        return request({
            url: '/workday/delete',
            method: 'delete',
            params: { oid },
            data: ids, // `ids` 作为请求体发送
        });
    },

    importData(oid, data) {
        return request({
            url: '/workday/import',
            method: 'post',
            params: { oid },
            data
        });
    },

    fetchData(oid) {
        return request({
            url: '/workday/findRecentChangedData',
            method: 'get',
            params: { oid } // 确保参数名称与后端接口匹配
        });
    },
    searchData(oid, keyword) {
        return request({
            url: '/workday/search',
            method: 'get',
            params: { oid, keyword }
        });
    },
    searchEmployees(oid, keyword) {  // 确保参数顺序和类型与 employeeService.searchData 一致
        return employeeService.searchData(oid, keyword);
    }
};
